import { cva } from 'class-variance-authority'

export const statusBadgeVariants = cva(
  'inline-flex items-center gap-2 rounded-md pl-1 pr-4 py-1 text-sm font-semibold text-white',
  {
    variants: {
      status: {
        active: 'bg-active',
        inactive: 'bg-incident',
      },
    },
    defaultVariants: {
      status: 'active',
    },
  }
)

export const statusBadgeIconVariants = cva(
  'inline-flex size-5 shrink-0 rounded-sm items-center justify-center bg-white',
  {
    variants: {
      status: {
        active: 'text-active',
        inactive: 'text-incident',
      },
    },
    defaultVariants: {
      status: 'active',
    },
  }
)
